/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Action_UpdateInputs */

const cs_gdpr_action_update = /** @type {(inputs: Gdpr_Action_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna`)
};

const en_gdpr_action_update = /** @type {(inputs: Gdpr_Action_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed`)
};

/**
* | output |
* | --- |
* | "Changed" |
*
* @param {Gdpr_Action_UpdateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_action_update = /** @type {((inputs?: Gdpr_Action_UpdateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Action_UpdateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_action_update(inputs)
	return cs_gdpr_action_update(inputs)
});